module.exports = __webpack_public_path__ + "static/media/other-square.f2bc4df5.jpg";